class ShelfProductTileOfferController {
    constructor($sce) {
        this.$sce = $sce;
    }

    $onInit() {
        this.getTagStyles();
    }

    getTagStyles() {
        if (!this.headerTag) {
            return;
        }

        if (this.headerTag.BorderColor) {
            this.containerStyle = { border: `2px solid ${this.headerTag.BorderColor}` };
        }

        this.tagStyle = {
            background: this.headerTag.BackgroundColor,
            'border-bottom-color': this.headerTag.BorderColor,
            color: this.headerTag.TextColor,
        };
    }
}

const shelfProductTileOfferComponentDefinition = {
    bindings: {
        headerTag: '<',
        classModifier: '@?',
    },
    controller: ['$sce', ShelfProductTileOfferController],
    template: require('./shelf-product-tile-offer.component.html').trim(),
};

module.exports = {
    ShelfProductTileOfferController,
    shelfProductTileOfferComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelf-product-tile-offer.component.js